/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreStandardTaskResponseDto } from '../../models/core-standard-task-response-dto';

export interface StandardTasksControllerFindAllByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;
}

export function standardTasksControllerFindAllByTenant(http: HttpClient, rootUrl: string, params: StandardTasksControllerFindAllByTenant$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreStandardTaskResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, standardTasksControllerFindAllByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreStandardTaskResponseDto>>;
    })
  );
}

standardTasksControllerFindAllByTenant.PATH = '/o2-core/standard-tasks/{tenant}';
